import React from 'react';
import PropTypes from 'prop-types';
import { ScrollToTop } from '../components/scroll-to-top';
import ErrorMessage from '../components/error-message';
import Loader from '../components/loader';

class RouteRenderer extends React.Component {
  constructor(props) {
    super(props);

    this.renderers = this.createRenderers();
    this.fallbackRender = <Loader fadeIn={false} />;
  }

  shouldComponentUpdate(nextProps) {
    return (
      nextProps.data !== this.props.data || nextProps.state !== this.props.state
    );
  }

  createRenderers() {
    const { staticContext, routeConfig } = this.props;
    /**
        Builds an object containing all render functions for all routes.
        Used both for classic and normal routing
      * */
    return Object.keys(routeConfig).reduce(
      (allRenderers, routeName) =>
        Object.assign(allRenderers, {
          // eslint-disable-next-line react/prop-types
          [routeName]: ({
            name,
            match,
            location,
            data,
            fetchMoreData,
            activeCampaign,
            market,
            isAuthenticated,
          }) => {
            const { component, isPrivate } = routeConfig[routeName];
            const routeSection =
              (match && match.params && match.params.section) || undefined;

            const MainComponent = component;

            if (!MainComponent) {
              return `no 'main' set for route ${routeName}`;
            }

            if (isPrivate && !isAuthenticated) {
              if (staticContext) {
                staticContext.status = 401;
              }

              return (
                <ScrollToTop key={location.key}>
                  <ErrorMessage status={401} />
                </ScrollToTop>
              );
            }

            const paramsId =
              match && match.params && (match.params.id || match.params.slug);
            const paramsName = match && match.params && match.params.name;
            const key = `${name}_${paramsId}_${paramsName}`;

            return (
              <ScrollToTop key={key}>
                <MainComponent
                  fallback={this.fallbackRender}
                  key={key}
                  data={data}
                  fetchMoreData={fetchMoreData}
                  activeCampaign={activeCampaign}
                  market={market}
                  routeName={routeName}
                  routeSection={routeSection}
                />
              </ScrollToTop>
            );
          },
        }),
      {}
    );
  }

  render() {
    if (!this.renderers[this.props.name]) {
      return null;
    }
    return this.renderers[this.props.name](this.props);
  }
}

RouteRenderer.propTypes = {
  name: PropTypes.string.isRequired,
  data: PropTypes.object,
  isAuthenticated: PropTypes.bool,
  staticContext: PropTypes.object,
  routeConfig: PropTypes.object.isRequired,
};

RouteRenderer.defaultProps = {
  data: undefined,
  isAuthenticated: false,
  staticContext: undefined,
};

export default RouteRenderer;
